import React, { useEffect, useState, useCallback } from "react";
import "./MyBookmarks.css";
import { useHistory } from "react-router-dom";
import {
  Typography, IconButton, Button,
  Card, CardContent, Grid, Box, Checkbox,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ShareIcon from "@mui/icons-material/Share";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BottomNav from "../../../components/Bottom nav/BottomNav";
import useBusinessQuery from "../../../store/Bussiness/useBusinessQuery";
import thumbnail from "../../../assets/thumbnail.png";
import locations from "../../../assets/locations.svg";

const RECENTLY_VIEWED_KEY = "mc_recently_viewed";
const MAX_RECENT = 30;

// ── Recently Viewed helpers (localStorage) ──────────────────────────────────
export const saveRecentlyViewed = (business) => {
  try {
    const raw = localStorage.getItem(RECENTLY_VIEWED_KEY);
    let list = raw ? JSON.parse(raw) : [];
    // Remove duplicate
    list = list.filter((b) => b.id !== business.id);
    // Prepend with timestamp
    list.unshift({ ...business, _viewedAt: new Date().toISOString() });
    // Cap list
    if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
  } catch (_) {}
};

const getRecentlyViewed = () => {
  try {
    const raw = localStorage.getItem(RECENTLY_VIEWED_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (_) {
    return [];
  }
};

const removeRecentlyViewed = (id) => {
  try {
    const list = getRecentlyViewed().filter((b) => b.id !== id);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
  } catch (_) {}
};

const clearRecentlyViewed = () => {
  localStorage.removeItem(RECENTLY_VIEWED_KEY);
};

// ── Time ago helper ──────────────────────────────────────────────────────────
const timeAgo = (iso) => {
  if (!iso) return "";
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

// ── Bookmark Card — mirrors ProductCard layout exactly ───────────────────────
const BookmarkCard = ({ item, onRemove }) => {
  const history = useHistory();
  const local = JSON.parse(localStorage.getItem("user"));
  const { mutateAsync: addCalls } = useBusinessQuery.Add_calls();

  const handleOpen = () => {
    saveRecentlyViewed(item);
    history.push(`/product-details/${item.id}`);
  };

  const handleCalls = async () => {
    try { await addCalls({ business_id: parseInt(item.id) }); } catch (_) {}
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: item.name,
        text: `Check out ${item.name} on MasterClick`,
        url: `${window.location.origin}/product-details/${item.id}`,
      }).catch(() => {});
    } else {
      navigator.clipboard?.writeText(
        `${window.location.origin}/product-details/${item.id}`
      );
    }
  };

  return (
    <Card sx={{ minHeight: "115px", mx: 0.2, mt: 2 }}>
      <CardContent
        sx={{
          padding: "4px 12px !important",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          justifyContent: "space-evenly",
        }}
      >
        <Grid container spacing={1}>
          {/* ── Left: image ── */}
          <Grid item xs={5}>
            <div
              style={{ cursor: "pointer", width: "100%", height: "100%" }}
              onClick={handleOpen}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "105px",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={item.image || thumbnail}
                  alt={item.name}
                  width="100%"
                  height="105px"
                  style={{ objectFit: "cover", display: "block" }}
                />
                {/* inset shadow overlay */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    boxShadow: "inset 0 0 8px 2px rgba(0,0,0,0.35)",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
          </Grid>

          {/* ── Right: content ── */}
          <Grid item xs={7}>
            {/* Row 1: name + bookmark toggle + share */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                style={{
                  fontWeight: "600", fontSize: "12px", lineHeight: "14px",
                  flex: 1, cursor: "pointer",
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}
                onClick={handleOpen}
              >
                {item.name}
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
                {/* Share */}
                <Box
                  onClick={handleShare}
                  sx={{
                    width: "24px", height: "24px",
                    border: "1px solid rgba(238,238,238,1)",
                    borderRadius: "20px",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <ShareIcon style={{ color: "#2182B1", width: "13px", height: "13px" }} />
                </Box>
                {/* Remove bookmark */}
                <Box
                  onClick={() => onRemove(item.id)}
                  sx={{
                    width: "24px", height: "24px",
                    border: "1px solid rgba(238,238,238,1)",
                    borderRadius: "20px",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <Favorite style={{ color: "#ff0000", width: "13px", height: "13px" }} />
                </Box>
              </Box>
            </Box>

            {/* Row 2: location + plan badges */}
            <Box
              sx={{
                display: "flex", alignItems: "center",
                justifyContent: "space-between", marginTop: "5px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                <img src={locations} alt="" width="7.98px" height="12px" />
                <Typography style={{ fontSize: "12px", fontWeight: "500" }}>
                  {item.post_office || item.district_name || ""}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "4px", flexShrink: 0 }}>
                {item.is_premium && (
                  <Typography
                    style={{
                      backgroundColor: "rgba(34,139,34,1)",
                      minWidth: "40px", height: "16px", borderRadius: "4px",
                      color: "#fff", fontSize: "7px", fontWeight: "600",
                      display: "flex", justifyContent: "center", alignItems: "center",
                      padding: "0 3px",
                    }}
                  >
                    Standard
                  </Typography>
                )}
                {item.is_pro && (
                  <Typography
                    style={{
                      backgroundColor: "rgba(240,150,48,1)",
                      minWidth: "32px", height: "16px", borderRadius: "4px",
                      color: "#fff", fontSize: "7px", fontWeight: "600",
                      display: "flex", justifyContent: "center", alignItems: "center",
                      padding: "0 3px",
                    }}
                  >
                    Premium
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Row 3: sub-category with tag icon */}
            {(item.sub_category_name || item.sub_category) && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px", marginTop: "3px" }}>
                <LocalOfferIcon style={{ fontSize: "10px", color: "rgba(100,100,100,0.7)" }} />
                <Typography
                  style={{
                    fontSize: "11px", fontWeight: "500",
                    color: "rgba(100,100,100,1)",
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                  }}
                >
                  {item.sub_category_name || item.sub_category}
                </Typography>
              </Box>
            )}

            {/* Row 4: Call + WhatsApp buttons */}
            <Box sx={{ marginTop: "calc(7px + 6mm)", width: "100%" }}>
              <Grid container spacing={1} sx={{ paddingBottom: "4px" }}>
                <Grid item xs={6}>
                  <Button
                    component="a"
                    href={`tel:${item.mobile_number}`}
                    onClick={handleCalls}
                    variant="contained"
                    style={{
                      fontSize: "10px", borderRadius: "6px", width: "100%",
                      textTransform: "none", padding: "0", height: "29px",
                      background: "rgba(33,130,177,1)", gap: "4px",
                      color: "white", display: "flex",
                      alignItems: "center", justifyContent: "center",
                    }}
                    sx={{ "& .MuiButton-startIcon": { margin: "0px" } }}
                    startIcon={<CallIcon style={{ fontSize: "10px" }} />}
                  >
                    Call Now
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    component="a"
                    href={`https://wa.me/91${item.whatsapp_number}?text=Hello`}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    style={{
                      fontSize: "10px", borderRadius: "6px", width: "100%",
                      textTransform: "none", padding: "0",
                      background: "rgba(37,207,67,1)", height: "29px",
                      gap: "4px", color: "white", display: "flex",
                      alignItems: "center", justifyContent: "center",
                    }}
                    sx={{ "& .MuiButton-startIcon": { margin: "0px" } }}
                    startIcon={<WhatsAppIcon style={{ fontSize: "10px" }} />}
                  >
                    Whatsapp
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

// ── Recent Card — same full-width layout as BookmarkCard / ProductCard ───────
const RecentCard = ({ item, onRemove }) => {
  const history = useHistory();
  const { mutateAsync: addCalls } = useBusinessQuery.Add_calls();

  const handleOpen = () => {
    saveRecentlyViewed(item);
    history.push(`/product-details/${item.id}`);
  };

  const handleCalls = async () => {
    try { await addCalls({ business_id: parseInt(item.id) }); } catch (_) {}
  };

  return (
    <Card sx={{ minHeight: "115px", mx: 0.2, mt: 2 }}>
      <CardContent
        sx={{
          padding: "4px 12px !important",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          justifyContent: "space-evenly",
        }}
      >
        <Grid container spacing={1}>
          {/* ── Left: image ── */}
          <Grid item xs={5}>
            <div
              style={{ cursor: "pointer", width: "100%", height: "100%" }}
              onClick={handleOpen}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "105px",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={item.image || thumbnail}
                  alt={item.name}
                  width="100%"
                  height="105px"
                  style={{ objectFit: "cover", display: "block" }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    boxShadow: "inset 0 0 8px 2px rgba(0,0,0,0.35)",
                    pointerEvents: "none",
                  }}
                />
                {/* Viewed-time chip overlaid on image bottom */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 5,
                    left: 5,
                    background: "rgba(0,0,0,0.52)",
                    borderRadius: "4px",
                    padding: "2px 5px",
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <AccessTimeIcon style={{ fontSize: 9, color: "#fff" }} />
                  <span style={{ fontSize: 8, color: "#fff", fontWeight: 600 }}>
                    {timeAgo(item._viewedAt)}
                  </span>
                </div>
              </div>
            </div>
          </Grid>

          {/* ── Right: content ── */}
          <Grid item xs={7}>
            {/* Row 1: name + remove button */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                style={{
                  fontWeight: "600", fontSize: "12px", lineHeight: "14px",
                  flex: 1, cursor: "pointer",
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}
                onClick={handleOpen}
              >
                {item.name}
              </Typography>
              <Box
                onClick={() => onRemove(item.id)}
                sx={{
                  width: "24px", height: "24px",
                  border: "1px solid rgba(238,238,238,1)",
                  borderRadius: "20px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  cursor: "pointer", flexShrink: 0,
                }}
              >
                <CloseIcon style={{ color: "#9ab0be", width: "13px", height: "13px" }} />
              </Box>
            </Box>

            {/* Row 2: location + plan badges */}
            <Box
              sx={{
                display: "flex", alignItems: "center",
                justifyContent: "space-between", marginTop: "5px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                <img src={locations} alt="" width="7.98px" height="12px" />
                <Typography style={{ fontSize: "12px", fontWeight: "500" }}>
                  {item.post_office || item.district_name || ""}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "4px", flexShrink: 0 }}>
                {item.is_premium && (
                  <Typography
                    style={{
                      backgroundColor: "rgba(34,139,34,1)",
                      minWidth: "40px", height: "16px", borderRadius: "4px",
                      color: "#fff", fontSize: "7px", fontWeight: "600",
                      display: "flex", justifyContent: "center", alignItems: "center",
                      padding: "0 3px",
                    }}
                  >
                    Standard
                  </Typography>
                )}
                {item.is_pro && (
                  <Typography
                    style={{
                      backgroundColor: "rgba(240,150,48,1)",
                      minWidth: "32px", height: "16px", borderRadius: "4px",
                      color: "#fff", fontSize: "7px", fontWeight: "600",
                      display: "flex", justifyContent: "center", alignItems: "center",
                      padding: "0 3px",
                    }}
                  >
                    Premium
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Row 3: sub-category with tag icon */}
            {(item.sub_category_name || item.sub_category) && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px", marginTop: "3px" }}>
                <LocalOfferIcon style={{ fontSize: "10px", color: "rgba(100,100,100,0.7)" }} />
                <Typography
                  style={{
                    fontSize: "11px", fontWeight: "500",
                    color: "rgba(100,100,100,1)",
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                  }}
                >
                  {item.sub_category_name || item.sub_category}
                </Typography>
              </Box>
            )}

            {/* Row 4: Call + WhatsApp buttons */}
            <Box sx={{ marginTop: "calc(7px + 6mm)", width: "100%" }}>
              <Grid container spacing={1} sx={{ paddingBottom: "4px" }}>
                <Grid item xs={6}>
                  <Button
                    component="a"
                    href={`tel:${item.mobile_number}`}
                    onClick={handleCalls}
                    variant="contained"
                    style={{
                      fontSize: "10px", borderRadius: "6px", width: "100%",
                      textTransform: "none", padding: "0", height: "29px",
                      background: "rgba(33,130,177,1)", gap: "4px",
                      color: "white", display: "flex",
                      alignItems: "center", justifyContent: "center",
                    }}
                    sx={{ "& .MuiButton-startIcon": { margin: "0px" } }}
                    startIcon={<CallIcon style={{ fontSize: "10px" }} />}
                  >
                    Call Now
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    component="a"
                    href={`https://wa.me/91${item.whatsapp_number}?text=Hello`}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    style={{
                      fontSize: "10px", borderRadius: "6px", width: "100%",
                      textTransform: "none", padding: "0",
                      background: "rgba(37,207,67,1)", height: "29px",
                      gap: "4px", color: "white", display: "flex",
                      alignItems: "center", justifyContent: "center",
                    }}
                    sx={{ "& .MuiButton-startIcon": { margin: "0px" } }}
                    startIcon={<WhatsAppIcon style={{ fontSize: "10px" }} />}
                  >
                    Whatsapp
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

// ── Main Page ────────────────────────────────────────────────────────────────
const MyBookmarks = () => {
  const local = JSON.parse(localStorage.getItem("user"));
  const [search, setSearch] = useState("");
  const [recentList, setRecentList] = useState([]);

  const { data: bookmarkData, isLoading: bmLoading } =
    useBusinessQuery.Get_bookmark_list(local?.id);
  const { mutateAsync: toggleBookmark } = useBusinessQuery.Add_bookmark();

  // Load recently viewed from localStorage
  useEffect(() => {
    setRecentList(getRecentlyViewed());
  }, []);

  const handleRemoveBookmark = useCallback(
    async (id) => {
      try {
        await toggleBookmark(id);
      } catch (_) {}
    },
    [toggleBookmark]
  );

  const handleRemoveRecent = useCallback((id) => {
    removeRecentlyViewed(id);
    setRecentList(getRecentlyViewed());
  }, []);

  const handleClearRecent = () => {
    clearRecentlyViewed();
    setRecentList([]);
  };

  const bookmarks = bookmarkData?.data?.results || [];
  const filtered = search.trim()
    ? bookmarks.filter(
        (b) =>
          b.name?.toLowerCase().includes(search.toLowerCase()) ||
          b.category_name?.toLowerCase().includes(search.toLowerCase()) ||
          b.sub_category_name?.toLowerCase().includes(search.toLowerCase()) ||
          b.post_office?.toLowerCase().includes(search.toLowerCase())
      )
    : bookmarks;

  return (
    <div className="mbk-root">
      {/* ── Header ── */}
      <div className="mbk-header">
        <Typography className="mbk-header-title">My Bookmarks</Typography>
        <Typography className="mbk-header-sub">
          {bookmarks.length} saved · {recentList.length} recently viewed
        </Typography>
      </div>

      <div className="mbk-body">

        {/* ── Section 1: Bookmarks ── */}
        <div className="mbk-section">
          <div className="mbk-section-header">
            <div className="mbk-section-title-row">
              <BookmarkIcon sx={{ fontSize: 18, color: "#2182B1" }} />
              <Typography className="mbk-section-title">Saved Businesses</Typography>
              {bookmarks.length > 0 && (
                <span className="mbk-count-chip">{bookmarks.length}</span>
              )}
            </div>

            {/* Search */}
            {bookmarks.length > 0 && (
              <div className="mbk-search-wrap">
                <SearchIcon sx={{ fontSize: 16, color: "#9ab0be" }} />
                <input
                  className="mbk-search-input"
                  placeholder="Search bookmarks…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                {search && (
                  <CloseIcon
                    sx={{ fontSize: 15, color: "#9ab0be", cursor: "pointer" }}
                    onClick={() => setSearch("")}
                  />
                )}
              </div>
            )}
          </div>

          {bmLoading ? (
            <div className="mbk-loading-row">
              {[1, 2, 3].map((i) => (
                <div key={i} className="mbk-skeleton" />
              ))}
            </div>
          ) : filtered.length === 0 ? (
            <div className="mbk-empty">
              <BookmarkBorderIcon sx={{ fontSize: 44, color: "#c5d8e3" }} />
              <Typography className="mbk-empty-title">
                {search ? "No results found" : "No bookmarks yet"}
              </Typography>
              <Typography className="mbk-empty-sub">
                {search
                  ? "Try a different search term"
                  : "You haven't bookmarked any businesses yet."}
              </Typography>
            </div>
          ) : (
            <div className="mbk-cards-list">
              {filtered.map((item) => (
                <BookmarkCard
                  key={item.id}
                  item={item}
                  onRemove={handleRemoveBookmark}
                />
              ))}
            </div>
          )}
        </div>

        {/* ── Section 2: Recently Viewed ── */}
        <div className="mbk-section">
          <div className="mbk-section-header">
            <div className="mbk-section-title-row">
              <AccessTimeIcon sx={{ fontSize: 18, color: "#2182B1" }} />
              <Typography className="mbk-section-title">Recently Viewed</Typography>
              {recentList.length > 0 && (
                <span className="mbk-count-chip">{recentList.length}</span>
              )}
            </div>
            {recentList.length > 0 && (
              <Button
                className="mbk-clear-btn"
                size="small"
                startIcon={<ClearAllIcon sx={{ fontSize: 14 }} />}
                onClick={handleClearRecent}
              >
                Clear All
              </Button>
            )}
          </div>

          {recentList.length === 0 ? (
            <div className="mbk-empty">
              <AccessTimeIcon sx={{ fontSize: 44, color: "#c5d8e3" }} />
              <Typography className="mbk-empty-title">No recent activity</Typography>
              <Typography className="mbk-empty-sub">
                Businesses you visit will appear here.
              </Typography>
            </div>
          ) : (
            <div className="mbk-recent-list">
              {recentList.map((item) => (
                <RecentCard
                  key={item.id}
                  item={item}
                  onRemove={handleRemoveRecent}
                />
              ))}
            </div>
          )}
        </div>

      </div>

      <BottomNav />
    </div>
  );
};

export default MyBookmarks;
